import React, { useState, useEffect } from 'react';
import ThingsToDoBanner from './ThingsToDoBanner';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { apiData } from '../../../actions';
import DataLoader from '../../../Utils/DataLoader';

export default function FilterPopularThings() {
    const params = useParams();
    const [loader, setLoader] = useState(false);
    const [popularDeals, setPopularDeal] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);


    const category = params.category || params.value || "";
    const cityFromUrl = params.sub || "";


    const place = useSelector(state => state.place);

    const finalCity = cityFromUrl || (
        place && place.toLowerCase() !== category.toLowerCase()
            ? place
            : ""
    );


    // 🔥 Extract keyword from URL

    const handlePopularDealClick = async (page = 1) => {
        try {
            setLoader(true);
            const payload = {
                city: finalCity, // city
                keyword: category,          // Shopping
                currentPage: page,
            };

            const apiRes = await apiData.getYelpPopularThings(payload);

            if (apiRes?.status >= 200 && apiRes?.status <= 399) {
                setPopularDeal(apiRes.data.data || []);
                setTotalPages(apiRes.data.totalPages || 1);
                setCurrentPage(page);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        handlePopularDealClick(1);
    }, [category, place]);

    const renderPagination = () => {
        if (totalPages <= 1) return null;

        const isMobile = window.innerWidth < 768;
        const pages = [];
        pages.push(1);

        if (isMobile) {
            // Mobile: Show first page, 3 digits around current page, and last page
            if (currentPage > 4) pages.push("...");

            let start = Math.max(2, currentPage - 1);
            let end = Math.min(totalPages - 1, currentPage + 1);

            if (currentPage <= 4) {
                start = 2;
                end = Math.min(4, totalPages - 1);
            }

            if (currentPage >= totalPages - 3) {
                start = Math.max(totalPages - 3, 2);
                end = totalPages - 1;
            }

            for (let i = start; i <= end; i++) pages.push(i);

            if (end < totalPages - 1) pages.push("...");
        } else {
            // Desktop: Original logic
            if (currentPage > 6) pages.push("...");

            let start = Math.max(2, currentPage - 2);
            let end = Math.min(totalPages - 1, currentPage + 2);

            if (currentPage <= 6) {
                start = 2;
                end = Math.min(10, totalPages - 1);
            }

            if (currentPage >= totalPages - 5) {
                start = Math.max(totalPages - 9, 2);
                end = totalPages - 1;
            }

            for (let i = start; i <= end; i++) pages.push(i);

            if (end < totalPages - 1) pages.push("...");
        }

        if (totalPages > 1) pages.push(totalPages);

        return (
            <nav aria-label="Page navigation">
                <ul className="pagination justify-content-center my-3">
                    {/* Previous */}
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                        <button
                            type="button"
                            className="page-link"
                            onClick={() => handlePopularDealClick(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            <svg width="7" height="12" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 13L1 7L7 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </li>

                    {/* Page Numbers */}
                    {pages.map((page, index) => (
                        <li
                            key={index}
                            className={`page-item ${currentPage === page ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                        >
                            {page === "..." ? (
                                <span className="page-link">...</span>
                            ) : (
                                <button
                                    type="button"
                                    className="page-link"
                                    onClick={() => handlePopularDealClick(page)}
                                >
                                    {page}
                                </button>
                            )}
                        </li>
                    ))}

                    {/* Next */}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                        <button
                            type="button"
                            className="page-link"
                            onClick={() => handlePopularDealClick(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            <svg width="7" height="12" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 13L7 7L1 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </button>
                    </li>
                </ul>
            </nav>
        );
    };

    if (loader) return <DataLoader />;

    return (
        <div>
            <ThingsToDoBanner />
            <div className='container-fluid top-spacing-120 pb-5'>
                {popularDeals.length > 0 ? (
                    <div className="row">
                        {popularDeals.map((ele, index) => (

                            <div className="col-md-6 col-lg-4 col-xl-3" key={index}>
                                <div className="card-item">
                                    <div className="resorts-box p-3 bg-white h-100">
                                        <figure>
                                            <img
                                                src={ele?.image_url}
                                                alt="images"
                                                loading="lazy"
                                                className="img-fluid"
                                            />
                                        </figure>

                                        <div className="resorts-content-box">
                                            <div className="d-flex justify-content-between">
                                                <span className="rating-star">
                                                    <i className="fa-solid fa-star"></i>
                                                    {ele?.rating} Overall Reviews
                                                </span>
                                            </div>

                                            <div className="resort-description border-0 m-0">
                                                <h3>
                                                    {ele?.name?.length >= 25
                                                        ? `${ele.name.slice(0, 25)}...`
                                                        : ele?.name}
                                                </h3>
                                            </div>

                                            <div className="book-trip-btn">
                                                <a
                                                    href={ele?.url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="w-100 text-center d-block"
                                                >
                                                    View
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p>No popular deals found.</p>
                )}
                {renderPagination()}
            </div>

        </div>
    );
}
